import React from "react";
import Loader from "./Loader";
import {
  AUTH_TOKEN,
  DEFAULT_IATA_CURRENCY,
  DEFAULT_IATA_ID,
  ENV_MAPPER,
  PLUGIN_AUTH_TOKEN,
  REFRESH_TOKEN,
  SELECTED_ORGANIZATION,
} from "utils/constants";
import { commitMutation, QueryRenderer as QR } from "react-relay";
import {
  Environment,
  Network,
  RecordSource,
  Store,
  fetchQuery as fQ,
} from "relay-runtime";
import { Cookies } from "react-cookie";
import CHOICES from "CHOICES";
import { ndcAPIs } from "./ndcAPIs";
import { generateRedirectAppUrl, setLocalStorage } from "./utils";
import { isEmpty } from "lodash";
import { logout } from "api/client";
import { env } from "config/env";

const cookie = new Cookies();
const handlerProvider = null;
const source = new RecordSource();
const store = new Store(source);
let subscriptionID = "";

const network = Network.create(
  function fetchQuery(operation, variables, cacheConfig, uploadables) {
    // MIGRATE TO: https://github.com/relay-tools/react-relay-network-modern
    // const authToken = cookie.get(AUTH_TOKEN);
    const authToken = JSON.parse(sessionStorage.getItem(AUTH_TOKEN) || "null");
    let headers: any = { "Content-Type": "application/json" };
    const selectedOrganisation = new Cookies().get(SELECTED_ORGANIZATION);
    headers["X-nf-active-org-short-code"] = selectedOrganisation?.group || "";
    // A plugin-established session has no backend session cookie to authenticate
    // credentials:"include" requests with, so attach the plugin token directly —
    // the same JWT-header scheme nf-travel-copilot uses to call this same backend.
    const pluginAuthToken = JSON.parse(
      sessionStorage.getItem(PLUGIN_AUTH_TOKEN) || "null",
    );
    if (pluginAuthToken) {
      headers["Authorization"] = "JWT " + pluginAuthToken;
    }
    if (authToken) {
      // headers["Authorization"] = "Bearer " + authToken;
      // const publicKey = cookie.get("publicKey");
      // jwt.verify(
      //   authToken,
      //   publicKey?.jwtPublicKey,
      //   { algorithms: ["RS256"] },
      //   (err: any, decoded: any) => {
      //     if (err) {
      //       // cookie.remove(AUTH_TOKEN, { path: "/" });
      //       // cookie.remove(REFRESH_TOKEN, { path: "/" });
      //       // cookie.remove("publicKey", { path: "/" });
      //       setLocalStorage("error", "Signature has expired");
      //       console.log("error in jwt verify");
      //       console.log(publicKey);
      //       window.location.replace("/");
      //       return;
      //     }
      //   }
      // );
    }
    // console.log("operation?.name1", operation?.name);
    return fetch(`${import.meta.env.VITE_APP_API_URL}/graphql`, {
      // return fetch(`https://api.dev.nuflights.com/core/graphql`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        query: operation.text, // GraphQL text from input
        variables,
      }),
      credentials: "include",
    })
      .then((response) => {
        const json = response.json();
        json.then((data: any) => {
          const errors = data?.errors;
          if (!isEmpty(errors)) {
            const isExpired = errors.some(
              (er: any) =>
                er.message.search(
                  "Authentication credentials were not provided or are invalid",
                ) !== -1,
            );
            if (isExpired) {
              // console.log(errors, "expired");
              // window.localStorage.clear();
              // window.sessionStorage.clear();
              // cookie.remove(AUTH_TOKEN, { path: "/" });
              // cookie.remove(REFRESH_TOKEN, { path: "/" });
              // window.location.replace(generateRedirectAppUrl("home"));
              logout();
            }
          }
        });
        return json;
      })
      .then((json) => {
        if (json?.data === null) {
          json.data = {
            [operation.name]: null,
          };
        }
        if (!isEmpty(json?.errors) && Array.isArray(json?.errors)) {
          const isExpired = json.errors.some(
            (er: any) =>
              er.message.search(
                "Authentication credentials were not provided or are invalid",
              ) !== -1,
          );
          if (isExpired) {
            // window.localStorage.clear();
            // window.sessionStorage.clear();
            // cookie.remove(AUTH_TOKEN, { path: "/" });
            // cookie.remove(REFRESH_TOKEN, { path: "/" });
            // window.location.replace(generateRedirectAppUrl("home"));
            logout();
          }
        }

        return json;
      });
  },
);

const ndcNetwork = Network.create(
  function fetchQuery(operation, variables, cacheConfig, uploadables) {
    // MIGRATE TO: https://github.com/relay-tools/react-relay-network-modern
    // const authToken = cookie.get(AUTH_TOKEN);
    const authToken = JSON.parse(sessionStorage.getItem(AUTH_TOKEN) || "null");
    const defaultIataID = window.sessionStorage.getItem(DEFAULT_IATA_ID);
    const defaultIataCurrency: any = window.sessionStorage.getItem(
      DEFAULT_IATA_CURRENCY,
    );
    let headers: any = { "Content-Type": "application/json" };
    const selectedOrganisation = new Cookies().get(SELECTED_ORGANIZATION);
    headers["X-nf-active-org-short-code"] = selectedOrganisation?.group || "";
    const pluginAuthToken = JSON.parse(
      sessionStorage.getItem(PLUGIN_AUTH_TOKEN) || "null",
    );
    if (pluginAuthToken) {
      headers["Authorization"] = "JWT " + pluginAuthToken;
    }
    if (authToken) {
      // headers["Authorization"] = "Bearer " + authToken;
    }
    // if (
    //   defaultIataID &&
    //   String(defaultIataID) !== String(null) &&
    //   String(defaultIataID) !== String(undefined)
    // ) {
    //   headers["IATA-Profile-ID"] = defaultIataID;
    // }
    // if (!isEmpty(subscriptionID)) {
    //   headers["Subscription-ID"] = subscriptionID.split(" ")[0];
    // }
    // if (!isEmpty(defaultIataCurrency)) {
    //   const currencyList: any = CHOICES.CurrencyCode;
    //   headers["IATA-Profile-Currency"] = currencyList[defaultIataCurrency];
    // }
    let apiEndpoint = "";
    // console.log("operation?.name2", operation?.name);
    if (ndcAPIs.includes(operation?.name)) {
      apiEndpoint = `${import.meta.env.VITE_APP_NDC_CONTENT}`;
      // apiEndpoint = `https://api.dev.nuflights.com/ndc-connect`;
    } else {
      apiEndpoint = `${import.meta.env.VITE_APP_API_URL}/graphql`;
      // apiEndpoint = `https://api.dev.nuflights.com/core/graphql`;
    }
    // return fetch(`${process.env.REACT_APP_API_URL}/graphql`, {
    return fetch(apiEndpoint, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        query: operation.text, // GraphQL text from input
        variables,
      }),
      credentials: "include",
    }).then((response) => {
      const json = response.json();
      json.then((res: any) => {
        if (res?.data == null) {
          res.data = {
            [operation?.name]: null,
          };
        }
      });
      return json;
    });
    // .then((response) => {
    //   return response.json();
    // });
  },
);

const environment = new Environment({
  handlerProvider,
  network,
  store,
});

const ndcEnvironment = new Environment({
  handlerProvider,
  network: ndcNetwork,
  store,
});

// function mutateBase(props: any) {
//   const onCompleted = (response: any, errors: any) => {
//     if (errors && errors.length > 0) {
//       var messages: string[] = [];
//       errors.forEach((err: any) => {
//         messages.push(err.message);
//       });
//       if (props.onFailure) {
//         return props.onFailure(messages);
//       } else {
//         return alert(messages.join("; "));
//       }
//     }
//     return props.onSuccess(response);
//   };
//   return commitMutation(props.environment, {
//     mutation: props.mutation,
//     variables: props.variables,
//     onCompleted: onCompleted,
//   });
// }
function mutateBase(props: any) {
  const onCompleted = (response: any, errors: any) => {
    if (errors && errors.length > 0) {
      var messages: string[] = [];
      errors.forEach((err: any) => {
        messages.push(err.message);
      });
      if (props.onFailure) {
        return props.onFailure(messages);
      } else {
        return alert(messages.join("; "));
      }
    }
    return props.onSuccess(response);
  };
  const onError = (error: any) => {
    if (props.onFailure) {
      return props.onFailure([error.message]);
    } else {
      return alert(error.message);
    }
  };
  return commitMutation(props.environment, {
    mutation: props.mutation,
    variables: props.variables,
    onCompleted: onCompleted,
    onError: onError,
  });
}

function mutate(props: any) {
  const variables = { input: props.input };
  return mutateBase({
    mutation: props.mutation,
    variables: variables,
    onSuccess: props.onSuccess,
    onFailure: props.onFailure,
    environment,
  });
}

function ndcMutate(props: any) {
  subscriptionID = props.subscriptionID;
  const variables = {
    rq: props.input,
    transactionId: props?.transactionId || null,
  };
  return mutateBase({
    mutation: props.mutation,
    variables: variables,
    onSuccess: props.onSuccess,
    onFailure: props.onFailure,
    environment: ndcEnvironment,
  });
}

function QueryRenderer(_props: any) {
  const component = (
    <QR
      environment={environment}
      render={({ error, props }: { error: any; props: any }) => {
        if (error) {
          return <div> {error.message} </div>;
        }
        if (props && Object.keys(props).length > 0) {
          return _props.onSuccess(props);
        }
        if (_props.isTable) {
          return (
            <tr>
              <td>Loading...</td>
            </tr>
          );
        }
        if (_props.isSelect) {
          return <option>Loading...</option>;
        } else {
          return <Loader />;
        }
      }}
      {..._props}
    />
  );
  return component;
}

function fetchQuery(query: any, variables = {}) {
  return fQ(environment, query, variables);
}

function fetchNdcQuery(query: any, variables = {}, header: string = "") {
  subscriptionID = header;
  return fQ(ndcEnvironment, query, variables);
}

export {
  QueryRenderer,
  mutate,
  fetchQuery,
  environment,
  mutateBase,
  ndcMutate,
  fetchNdcQuery,
};
